import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '../core/route.service';
import { extract } from '../core/i18n.service';
import { ItineraryReservationComponent } from './itinerary-reservation.component';
import { ConfirmReservationComponent } from './confirm-reservation/confirm-reservation.component';

const routes: Routes =[
    { path: 'itinerary-reservation', component: ItineraryReservationComponent, data: { title: extract('Reserva de itinerario') } },
    //{ path: 'itinerary-reservation-config', component: ItineraryReservationComponent, data: { title: extract('Itinerary Reservation') } },
    // { path: 'reservation-confirmation', component: ItineraryReservationComponent, data: { title: extract('Itinerary Reservation') } },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})
export class ItineraryReservationRoutingModule { }
